module.exports = __webpack_public_path__ + "videos/video-1025.93a83e2.webm";